import { render, staticRenderFns } from "./TicketConfig.vue?vue&type=template&id=203c404e&scoped=true"
import script from "./TicketConfig.vue?vue&type=script&lang=js"
export * from "./TicketConfig.vue?vue&type=script&lang=js"
import style0 from "./TicketConfig.vue?vue&type=style&index=0&id=203c404e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c404e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203c404e')) {
      api.createRecord('203c404e', component.options)
    } else {
      api.reload('203c404e', component.options)
    }
    module.hot.accept("./TicketConfig.vue?vue&type=template&id=203c404e&scoped=true", function () {
      api.rerender('203c404e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/TicketConfig.vue"
export default component.exports